module.exports = __webpack_public_path__ + "neverForget.png?d7f60731a413f1d6e0ca9c8f7fae0d87";